import { GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE, GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS, RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION } from "../Action/actionTypes"

interface State {
    closeNegotiationAIsummary: object
}

const initialState: State = {
    closeNegotiationAIsummary: {}
}


const CloseNegotiationReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_SUCCESS: return {
            ...state,
            closeNegotiationAIsummary: action.payload
        }

        case GET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION_FAILURE: return {
            ...state,
            closeNegotiationAIsummary: {}
        }

        case RESET_AI_SUMMARY_FOR_CLOSE_NEGOTIATION: return {
            ...state,
            ...initialState
        }
        default: return state
    }
}

export default CloseNegotiationReducer;